import { Container } from "react-bootstrap";
import CountdownTimer from "./TimeCountDown";

function Support() {
  return (
    <Container>
      <div style={{ overflowX: "hidden", fontFamily: "" }} dir="rtl" lang="ar">
        <br />
        <br />
        <h1>الدعم:</h1>
        <br />
        <br />
        <p>
          تعتمد الصفحة على متابعة أسعار العيارات المختلفة للذهب في السوق المحلي
          في مصر
        </p>
        <p>تتم أيضا متابعة أسعار الذهب العالمية مقدرة بالدولار الأمريكي</p>
        <p>
          يتم تقدير السعر التحوطي للدولار الأمريكي في الأسواق المصرية بناء على
          مقارنة سعر الذهب المحلي و العالمي
        </p>
        <p>يتم تحديث الأسار أولا بأول</p>
        <br />
        <p>للتواصل معنا: ali.elhall@gmail.com</p>
        <p>
          الأسعار في الصفحة إرشادية فقط و لا يمكن البناء عليها في أي عمليات
          تجارية أو في البيع أو الشراء لأي نوع من أنواع السلع أو العملات
        </p>
      </div>
      <CountdownTimer />
    </Container>
  );
}

export default Support;
